import React, {Component} from 'react';
import Api from "../../utils/Api";
import moment from "moment/moment";
import StaticFunctions from "../../utils/StaticFunctions";
import TimeRange from "../../utils/TimeRange";
import CSVDownloadButton from "../../utils/CSVDownloadButton";
import TimerangeSelector from "../../globalComponents/TimerangeSelector";
import LocationSelector from "../../globalComponents/LocationSelector";
import MachineSelector from "../../globalComponents/MachineSelector";
import DesignSelector from "../../globalComponents/DesignSelector";
import ShiftSelector from "../../globalComponents/ShiftSelector";
import TableContainer from "../../utils/TableContainer";
import DesignPreviewContainer from "../../utils/DesignPreviewContainer";
import LoadingSplash from "../../globalComponents/LoadingSplash";
import Timeformat from "../../utils/Timeformat";
import OutlierSelector from "../../globalComponents/OutlierSelector";

class ReportRunningtime extends Component {
/*
    static propTypes = {
        baseData: PropTypes.object.isRequired,
        machines: PropTypes.instanceOf(Machines).isRequired,
    };
*/
    constructor(props) {

        super(props);

        this.api = new Api();

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);
        this.saveSettings = this.props.baseData.saveSettings;
        this.excludedStatuscodes = [];

        this.state = {
            reportStatus: null,
            reportParams: null,
            timeRange: null, // TimeRange
            selectedLocationId: 0,
            selectedLocationName: 'all',
            selectedMachine: {value: 'all', label: this.translate('all')},
            selectedDesign: null,
            ignoreOutliers: 0,
            selectedShift: null,
            selectDetail: null,
            selectDetailIndex: null,
            designs: [],
            currentCompanyId: props.baseData.companies.currentCompany ? props.baseData.companies.currentCompany.id : null,
            requestedParams: null, // stringified parameters to prevent double-request
            tableData: null,
            detailTableData: null,
            errorData: null
        };

        this.reportKey = 'runningtime';

        this.updateDesigns = this.updateDesigns.bind(this);
        this.requestReport = this.requestReport.bind(this);
        this.timerangeChanged = this.timerangeChanged.bind(this);
        this.locationSelected = this.locationSelected.bind(this);
        this.machineSelected = this.machineSelected.bind(this);
        this.designSelected = this.designSelected.bind(this);
        this.outlierSelected = this.outlierSelected.bind(this);
        this.shiftSelected = this.shiftSelected.bind(this);
        this.setDetailTableData = this.setDetailTableData.bind(this);

    }

    componentWillMount() {

        this.updateDesigns();

        const newState = {};

        // Timerange aus den userprops laden
        const tr = new TimeRange();
        const momentYesterday = moment().add(-1, 'days');

        tr.setRange(momentYesterday.clone().startOf('day'), momentYesterday.clone().endOf('day'));

        if (tr && tr.isValid()) newState.timeRange = tr;

        // Standort aus den userprops laden
        const locationId = this.getReportSetting('locationId');

        if (locationId) newState.selectedLocationId = locationId;

        // Machines aus den userprops laden
        const machine = this.getReportSetting('machine');

        if (machine) newState.selectedMachine = JSON.parse(machine);

        // Design aus den userprops laden
        const design = this.getReportSetting('design');

        if (design) newState.selectedDesign = design;

        // Ignore outliers aus den userprops laden
        const ignoreOutliers = this.getReportSetting('ignoreOutliers');

        if (ignoreOutliers) newState.ignoreOutliers = ignoreOutliers;

        // Shift aus den userprops laden
        const sid = this.getReportSetting('shiftId');

        if (sid) {
            let shift = this.props.baseData.shifts.getShiftById(sid);

            if (shift) newState.selectedShift = shift;
        }

        if (newState) {
            this.setState(newState);
        }

    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.baseData.companies && nextProps.baseData.companies.currentCompany) {
            if (nextProps.baseData.companies.currentCompany.id !== this.state.currentCompanyId) {
                this.setState({
                    selectedLocationId: 0,
                    selectedLocationName: 'all',
                    selectedMachine: {value: 'all', label: this.translate('all')},
                    tableData: null,
                    detailTableData: null,
                    currentCompanyId: nextProps.baseData.companies.currentCompany.id
                });
            }
        }

    }

    getReportSetting(key, defaultValue = null) {

        const settings = this.props.baseData.userData.settings ? this.props.baseData.userData.settings : {};
        const reportSettings = (settings.hasOwnProperty('reports') && settings.reports.hasOwnProperty(this.reportKey)) ? settings.reports[this.reportKey] : {};

        return (reportSettings.hasOwnProperty(key)) ? reportSettings[key] : defaultValue;

    }

    updateDesigns() {

        const params = {
            "id_company": this.props.baseData.companies.currentCompany.id,
            'maxRows': this.state.maxEntries,
            'offset': this.state.maxEntries * this.state.currentPage
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    designs: res
                });
            }
        }.bind(this);

        this.api.request('GetDesigns', params, callback, null);

    }

    getRequestParams() {

        const tr = this.state.timeRange;
        const dateFrom = tr ? tr.getFromMoment() : null;
        const dateTill = tr ? tr.getTillMoment() : null;
        const locationId = this.state.selectedLocationId;
        const machineId = this.state.selectedMachine ? this.state.selectedMachine.value : null;
        const design = this.state.selectedDesign;
        const machineIds = (machineId === 'all') ? this.props.machines.getAllMachineIdsFromLocation(locationId) : [machineId];

        // Check, if all data is set
        if (!dateFrom || !dateTill || design === null || locationId === null) return;
        if (!dateFrom.isValid() || !dateTill.isValid()) return;

        return {
            action: 'getOverview',
            machineIds: machineIds,
            locationId: locationId,
            design: design,
            companyId: this.props.baseData.companies.currentCompany.id,
            from: dateFrom.unix(),
            till: dateTill.unix(),
            ignoreOutliers: this.state.ignoreOutliers,
            shift: this.state.selectedShift ? this.state.selectedShift.getRange() : null,
            timezone: this.props.baseData.companies.currentCompany.timezone,
        };

    }

    requestReport() {

        if (this.state.reportStatus === 'requested') return null;

        const params = this.getRequestParams();

        if (params === null) return null;

        const sParams = JSON.stringify(params);

        if (sParams === this.state.requestedParams) return null;

        const {reportParams, ...newReportParams} = {...this.state};

        const callback = function(res) {
            if (res) {
                const sortedRes = StaticFunctions.getSortedData(res, 'designId', 'string');

                this.setState({
                    reportStatus: 'ready',
                    reportParams: newReportParams,
                    tableData: sortedRes,
                    detailTableData: null,
                });
            }
        }.bind(this);

        const error = function(error) {
            if (error) {
                this.setState({
                    reportStatus: 'error',
                    tableData: null,
                    errorData: error,
                });
            }
        }.bind(this);

        this.setState({
            reportStatus: 'requested',
            requestedParams: sParams,
            tableData: null,
            detailTableData: null,
            errorData: null,
        }, () => {
            this.api.request('ReportRunningtime', params, callback, error);
        });

    }

    timerangeChanged(newRange) {

        if (newRange && (newRange instanceof TimeRange) && newRange.isValid()) {
            this.setState({
                timeRange: newRange,
            });

            // Safe Timerange to Userconfig
            if (this.saveSettings) {
                this.saveSettings('reports', {report: this.reportKey, key: 'timeRange', value: newRange.serialize()});
            }
        }

    }

    locationSelected(location) {

        const allMachines = {value: 'all', label: this.translate('all')};

        this.setState({
            selectedLocationId: location ? parseInt(location.id) : 0,
            selectedLocationName: location ? location.name : '',
            selectedMachine: allMachines
        });

        if (this.saveSettings && location) {
            this.saveSettings('reports', {report: this.reportKey, key: 'locationId', value: location.id});
            this.machineSelected(allMachines);
        }

    }

    machineSelected(machine) {

        this.setState({
            selectedMachine: machine
        });

        // Safe Machine to Userconfig
        if (this.saveSettings) {
            this.saveSettings('reports', {report: this.reportKey, key: 'machine', value: ((machine) ? JSON.stringify(machine) : null)});
        }

    }

    designSelected(design) {

        this.setState({
			selectedDesign: {id: design.designId, stitches: design.stitches}
        });

        // Safe Design to Userconfig
        if (this.saveSettings) {
            this.saveSettings('reports', {report: this.reportKey, key: 'design', value: JSON.stringify({id: design.designId, stitches: design.stitches})});
        }

    }

    outlierSelected(outlier) {

        this.setState({
            ignoreOutliers: outlier || 0
        });

        // Safe Outlier to Userconfig
        if (this.saveSettings) {
            this.saveSettings('reports', {report: this.reportKey, key: 'ignoreOutliers', value: (outlier || 0)});
        }

    }

    shiftSelected(shift) {

        this.setState({
            selectedShift: shift
        });

        // Safe Shift-id to Userconfig
        if (this.saveSettings && shift) {
            this.saveSettings('reports', {report: this.reportKey, key: 'shiftId', value: shift.id});
        }

    }

    setDetailTableData(data) {

        if (!data || !data.passes || data.passes.length === 0) return null;

        const tableData = data.passes.map(
            (pass) => {
                let startTime = pass[0].start;
                let endTime = pass[(pass.length - 1)].stop;
                let runningTime = this.getRunningtime(pass);

                return {
                    design: {id: pass[0].designId, stitches: pass[0].stitches},
                    locationId: pass[0].locationId,
                    locationName: pass[0].locationName,
                    machineId: pass[0].machineId,
                    machineName: pass[0].machineName,
                    startTime: startTime,
                    endTime: endTime,
                    runningTime: runningTime,
                };
            }
        );

        this.setState({
            detailTableData: tableData,
        });

    }

    getRunningtime(pass) {

        let fullRunningTime = 0;

        if (pass.length > 0) {
            pass.forEach(
                (row) => {
                    if (!this.excludedStatuscodes.includes(parseInt(row['status']))) fullRunningTime += parseInt(row['stop']) - parseInt(row['start']);
                }
            );
        }

        return Math.floor(fullRunningTime / 1000);

    }

    getErrorBlock() {

        let errorBlock = null;

        if (this.state.errorData || this.state.reportStatus === 'error') {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('errorOccured')}</span>;
        } else if (!this.state.reportParams.timeRange || !this.state.reportParams.timeRange.isValid()) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('timerangeIsUnset')}</span>;
        } else if (!this.state.reportParams.timeRange || !this.state.reportParams.timeRange.isNotInFuture()) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('timerangeIsInFuture')}</span>;
        } else if (this.state.reportParams.selectedLocationId === null) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('locationIsUnset')}</span>;
		} else if (!this.state.reportParams && this.state.reportParams.selectedDesign === null) {
			errorBlock = <span className="warningBox ma-bo-10">{this.translate('designIsUnset')}</span>;
        } else if (this.state.tableData === null) {
            errorBlock = <LoadingSplash color={'dark'}/>;
        } else if (this.state.tableData && this.state.tableData.length === 0) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('noDataFound')}</span>;
        }

        return (errorBlock !== null) ? errorBlock : null;

    }

    getChartHeadline(timeRange, otherParams = {}) {

        const params = {
            location: {id: this.state.reportParams.selectedLocationId, name: this.state.reportParams.selectedLocationName},
			locationTitle: this.translate('location'),
			allLocationsTitle: this.translate('allLocations'),
            machine: this.state.reportParams.selectedMachine,
            machineTitle: this.translate('machine'),
            allMachinesTitle: this.translate('allMachines'),
            design: this.state.reportParams.selectedDesign,
            designTitle: this.translate('design'),
			stitchesUnit: this.translate('stitches'),
            allDesignsTitle: this.translate('allDesigns'),
            timerange: timeRange,
            formatedDate: this.timeFormats.fullDate,
            timerangeTitle: this.translate('timerange'),
            shift: this.state.reportParams.selectedShift,
            shiftTitle: this.translate('shift'),
            groupingOpt: this.groupingOpt,
            groupingId: this.state.reportParams.selectedGrouping,
            groupingTitle: this.translate('grouping')
        };

        return StaticFunctions.createReportHeadlineFromParams({...params, ...otherParams});

    }

    getCsvContent() {

        const csvContent = {
            csvTitle: [],
            csvColumns: [],
            csvData: [],
        };

        if (this.state.reportStatus === 'ready') {

            const design = {
                design: ((this.state.reportParams.detailTableData && this.state.reportParams.detailTableData !== 0) ? this.state.reportParams.detailTableData[0].design : null),
                designTitle: this.translate('design'),
				stitchesUnit: this.translate('stitches'),
                allDesignsTitle: this.translate('allDesigns')
            };

            const custom = {
                custom: this.translate('details')
            };

            if (this.state.tableData !== null) {
                csvContent.csvTitle.push(this.getChartHeadline(this.state.reportParams.timeRange));
                csvContent.csvColumns.push(this.getOverviewTableColumns());
                csvContent.csvData.push(this.getOverviewTableRows());
            }

            if (this.state.detailTableData !== null) {
                csvContent.csvTitle.push(this.getChartHeadline(this.state.reportParams.timeRange, {...design, ...custom}));
                csvContent.csvColumns.push(this.getDetailTableColumns());
                csvContent.csvData.push(this.getDetailTableRows());
            }
        }

        return csvContent;

    }

    getOverviewTableHeader() {

        const headline = this.getChartHeadline(this.state.reportParams.timeRange, {}, 'overview');

        return (
            <nav>
                <h1>{headline}</h1>
            </nav>
        );

    }

    getOverviewTableColumns() {

        return [
            {
                key: 'img',
                nameKey: 'design',
            },
            {
                key: 'designId',
                nameKey: 'designId',
                sortType: 'string',
            },
			{
				key: 'stitches',
				nameKey: 'designStitches',
				classes: 'text-right',
				sortType: 'int',
			},
            {
                key: 'numberOfPasses',
                nameKey: 'numberOfPasses',
                classes: 'text-right',
                sortType: 'int',
            },
            {
                key: 'minRunningTime',
                nameKey: 'minRunningTime',
                classes: 'text-right',
                sortType: 'string',
            },
            {
                key: 'maxRunningTime',
                nameKey: 'maxRunningTime',
                classes: 'text-right',
                sortType: 'string',
            },
            {
                key: 'averageRunningTime',
                nameKey: 'averageRunningTime',
                classes: 'text-right',
                sortType: 'string',
            },
            {
                key: 'options',
                nameKey: 'options',
            },
        ];

    }

    getOverviewTableRows() {

        const tableData = this.state.tableData;
        const rows = [];

        if (tableData) {
            tableData.forEach(
                (data, index) => {
                    let options = (
                        <div className="tableOptions">
                            <a className="optionSearch" onClick={() => this.setDetailTableData(data)} title={this.translate('showDetails')}>&nbsp;</a>
                        </div>
                    );

                    rows.push({
                        id: index,
                        designId: data.designId,
						stitches: StaticFunctions.formatedNumber(data.stitches),
                        img: <DesignPreviewContainer baseData={this.props.baseData} designId={data.designId} designStitches={data.stitches}/>,
                        numberOfPasses: StaticFunctions.formatedNumber(+data.passes.length),
                        minRunningTime: StaticFunctions.convertSecondsToFormatedString(data.minRunningTime),
                        maxRunningTime: StaticFunctions.convertSecondsToFormatedString(data.maxRunningTime),
                        averageRunningTime: StaticFunctions.convertSecondsToFormatedString(data.averageRunningTime),
                        options: options,
                    });
                }
            );
        }

        return rows;

    }

    generateOverviewTable() {

        const tableHeader = this.getOverviewTableHeader();
        const tableColumns = this.getOverviewTableColumns();
        const tableRows = this.getOverviewTableRows();

        return (
            <div className="clearfix ma-bo-10">
                {tableHeader}

                <TableContainer
                    baseData={this.props.baseData}
                    columns={tableColumns}
                    rows={tableRows}
                    maxHeight={400}
                />
            </div>
        );

    }

    getDetailTableHeader() {

        const design = {
            design: ((this.state.detailTableData && this.state.detailTableData !== 0) ? this.state.detailTableData[0].design : null),
            designTitle: this.translate('design'),
			stitchesUnit: this.translate('stitches'),
            allDesignsTitle: this.translate('allDesigns')
        };

        const custom = {
            custom: this.translate('details')
        };

        const headline = this.getChartHeadline(this.state.reportParams.timeRange, {...design, ...custom});

        return (
            <nav>
                <h1>{headline}</h1>
            </nav>
        );

    }

    getDetailTableColumns() {

        return [
            {
                key: 'location',
                nameKey: 'location',
                sortType: 'string',
            },
            {
                key: 'machineId',
                nameKey: 'machineId',
                sortType: 'string',
            },
            {
                key: 'machineName',
                nameKey: 'machineName',
                sortType: 'string',
            },
            /*{
                key: 'img',
                nameKey: 'design',
            },
            {
                key: 'designId',
                nameKey: 'designId',
                sortType: 'string',
            },*/
            {
                key: 'startDate',
                nameKey: 'startDate',
                classes: 'text-right',
                sortType: 'datetime',
            },
            {
                key: 'endDate',
                nameKey: 'endDate',
                classes: 'text-right',
                sortType: 'datetime',
            },
            {
                key: 'runningTime',
                nameKey: 'runningTime',
                classes: 'text-right',
                sortType: 'string',
            },
        ];

    }

    getDetailTableRows() {

        const tableData = this.state.detailTableData;
        const rows = [];

        if (tableData) {
            tableData.forEach(
                (data, index) => {
                    let machine = this.props.machines.getMachineByMachineId(data.machineId);
                    let lastSeen = (data.startTime) ? Timeformat.fromUnix(data.startTime).getDateTime(this.props.baseData.companies.currentCompany.timezone) : '-';
                    let endTime = (data.startTime) ? Timeformat.fromUnix(data.endTime).getDateTime(this.props.baseData.companies.currentCompany.timezone) : '-';

                    rows.push({
                        id: index,
                        location: data.locationName,
                        machineId: data.machineId,
                        machineName: machine.alias,
                        designId: data.designId,
                        img: <DesignPreviewContainer baseData={this.props.baseData} designId={data.designId} designStitches={data.stitches}/>,
                        startDate: lastSeen,
                        endDate: endTime,
                        runningTime: StaticFunctions.convertSecondsToFormatedString(data.runningTime),
                    });
                }
            );
        }

        return rows;

    }

    generateDetailTable() {

        if (this.state.detailTableData === null) return null;

        const tableHeader = this.getDetailTableHeader();
        const tableColumns = this.getDetailTableColumns();
        const tableRows = this.getDetailTableRows();

        return (
            <div className="clearfix ma-bo-10">
                {tableHeader}

                <div className="col-xs-12">
                    <TableContainer
                        baseData={this.props.baseData}
                        columns={tableColumns}
                        rows={tableRows}
                    />
                </div>
            </div>
        );

    }

    renderRequestButton() {

        const reportParams = this.getRequestParams();
        const sParams = JSON.stringify(reportParams);

        if (this.state.reportStatus === 'requested' || sParams === this.state.requestedParams) {
            return (
                <a className="prewLink disabled-link">{this.translate('requestReport')}</a>
            );
        } else {
            return (
                <a className="prewLink orangeButton" onClick={() => this.requestReport()}>{this.translate('requestReport')}</a>
            );
        }

    }

    renderDownloadButtons() {

        if (this.state.reportStatus !== 'ready' || !this.state.reportParams || this.getErrorBlock() !== null) {
            return (
                <div className="bottomLinks clearfix">
                    <div><button className="disabled-link">{this.translate('csvDownloadLabel') + ' (CSV)'}</button></div>
                </div>
            );
        } else {
            const csvContent = this.getCsvContent();

            return (
                <div className="bottomLinks clearfix">
                    <CSVDownloadButton
                        baseData={this.props.baseData}
                        fileName={this.props.reportName}
                        csvTitle={csvContent.csvTitle}
                        columns={csvContent.csvColumns}
                        data={csvContent.csvData}
                    />
                </div>
            );
        }

    }

    renderReportArea() {

        if (this.state.reportStatus === null) return null;
        if (this.state.reportStatus === 'requested') return <LoadingSplash color={'dark'}/>;

        const errorBlock = this.getErrorBlock();

        if (errorBlock !== null) return errorBlock;

        const overviewTable = this.generateOverviewTable();
        const detailTable = this.generateDetailTable();

        return (
            <div>
                {overviewTable}

                {detailTable}
            </div>
        );

    }

    render() {

        const timerangeFormat = this.timeFormats.fullDate;
        const machineOptions = this.props.machines;
        const designOptions = this.state.designs;

        const reportArea = this.renderReportArea();
        const requestButton = this.renderRequestButton();
        const downloadArea = this.renderDownloadButtons();

        return (
            <div>
                <div id="reportSettings" className="clearfix">
                    <div className="clearfix">
                        <div className="col-sm-4">
                            <div className="ma-bo-10">
                                <h4>{this.translate('timerange')}</h4>

                                <div>
                                    <TimerangeSelector
                                        TimeRange={this.state.timeRange}
                                        displayFormat={timerangeFormat}
                                        translate={this.translate}
                                        onTimeRangeChanged={this.timerangeChanged}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-2">
                            <div className="ma-bo-10">
                                <h4>{this.translate('location')}</h4>

                                <div>
                                    <LocationSelector
                                        baseData={this.props.baseData}
                                        currentLocation={this.state.selectedLocationId}
                                        placeholder={this.translate('select') + '...'}
                                        onLocationSelected={(location) => this.locationSelected(location)}
                                    />
                                </div>
                            </div>

                            <div className="ma-bo-10">
                                <h4>{this.translate('machine')}</h4>

                                <div>
                                    <MachineSelector
                                        machine={machineOptions}
                                        currentMachine={this.state.selectedMachine}
                                        currentLocation={this.state.selectedLocationId}
                                        translate={this.translate}
                                        addAllOption={true}
                                        onMachineSelected={(machine) => this.machineSelected(machine)}
                                    />
                                </div>
                            </div>

                            <div className="ma-bo-10">
                                <h4>{this.translate('design')}</h4>

                                <div>
                                    <DesignSelector
                                        name="design-select"
                                        baseData={this.props.baseData}
                                        currentDesign={this.state.selectedDesign}
                                        designs={designOptions}
                                        translate={this.translate}
                                        onDesignSelected={(design) => this.designSelected(design)}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-2">
                            <div className="ma-bo-10">
                                <h4>{this.translate('ignoreOutliers')}</h4>

                                <div>
                                    <OutlierSelector
                                        baseData={this.props.baseData}
                                        currentOption={this.state.ignoreOutliers}
                                        onChange={(outlier) => this.outlierSelected(outlier)}
                                    />
                                </div>
                            </div>

                            <div className="ma-bo-10">
                                <h4>{this.translate('shift')}</h4>

                                <div>
                                    <ShiftSelector
                                        baseData={this.props.baseData}
                                        currentShift={this.state.selectedShift}
                                        onShiftSelected={(shift) => this.shiftSelected(shift)}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-2">
                            <div className="ma-bo-10">
                                <h4>{this.translate('downloadReport')}</h4>

                                {downloadArea}
                            </div>
                        </div>
                    </div>

                    <div className="bottomLinks clearfix">
                        {requestButton}
                    </div>
                </div>

                <div id="reportArea" className="clearfix">
                    {reportArea}
                </div>
            </div>
        );

    }

}

export default ReportRunningtime;
